/// <amd-module name="typeahead/core/handlebarHelpers" />
/// <amd-dependency path="handlebars" name="hbRuntime" />
import {locationIcon} from "typeahead/core/geolocation/GeolocationIcon";
import {IEssSuggestionResult, ISuggestionResult} from "typeahead/core/Suggestion";
// FROM https://gist.github.com/3902173
//
// HELPER: #each_with_key
//
// Usage: {{#each_with_key container key="myKey"}}...{{/each_with_key}}
//
// Iterate over an object containing other objects. Each
// inner object will be used in turn, with an added key ("myKey")
// set to the value of the inner object's key in the container.
hbRuntime.default.registerHelper("each_with_key", (obj, options) => {
    let context;
    let buffer = "";
    let key;
    let keyName = options.hash.key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            context = obj[key];
            if (keyName) {
                context[keyName] = key;
            }
            buffer += options.fn(context);
        }
    }
    return buffer;
});

// Helper to be called in hbs templates to display a suggestion according to the different business rules.
// CF content/hbs/templates/destinationCustom.hbs for example.
hbRuntime.default.registerHelper("createListItem", (suggestionResult: ISuggestionResult) => {
    function appendDistanceForNearbyAirportIfApplicable() {
        let html = suggestionResult.regionNames.displayName;
        // This feature is currently limited to en_GB and en_US because it is not yet localized. Proper localization
        // should translate "2 miles away" to "2 millas de distancia" for es_US and "3 km entfernt" for de_DE.
        let essSuggestionResult: IEssSuggestionResult = <IEssSuggestionResult> suggestionResult;
        let nearbyAirportMiles: number = essSuggestionResult.hierarchyInfo && essSuggestionResult.hierarchyInfo.nearby ?
            essSuggestionResult.hierarchyInfo.nearby.distInMI : undefined;
        if (nearbyAirportMiles) {
            html = html + " (" + Math.round(nearbyAirportMiles) + " miles away)";
        }
        return html;
    }

    function makeIconHtml() {
        let html;
        if (suggestionResult.showAsHierarchy) {
            html = `<span data-tid="typeahead-icon`
                + parseInt (suggestionResult.index, 10)
                + `" class="icon" aria-hidden="true">
                <svg class="uitk-icon-svg">
                    <use xlink:href="#uitk-icon-return"/>
                </svg></span>`;
        } else {
            if (suggestionResult.icon === "geolocation") {
                html = `<span data-tid="typeahead-icon` + suggestionResult.index + `" class="" aria-hidden="true">` +
                    `<img alt="" style="height:1em;width:1em;vertical-align:middle;margin-right:0.8em;" ` +
                    `src='` + locationIcon + `'/>` +
                    `</span>`;
            } else if (suggestionResult.icon === "none") {
                html = `<span data-tid="typeahead-icon`
                    + suggestionResult.index
                    + `" aria-hidden="true"/>`;
            } else {
                html = `<span data-tid="typeahead-icon`
                    + suggestionResult.index
                    + `" class="icon" aria-hidden="true">
                    <svg class="uitk-icon-svg">
                        <use xlink:href="#uitk-icon-` + suggestionResult.icon + `"/>
                    </svg>
                    </span>`;
            }
        }
        return html;
    }

    function createMultiLineHtml(topLeft, topRight, bottom) {
        let html: string = "<div class='multiLineDisplay'>";
        html += topLeft.trim();
        if (topRight) {
            html += topRight.trim();
        }
        if (bottom) {
            html += "<br>" + bottom.trim();
        }
        html += "</div>";
        return html;
    }

    function convertMainToMultiLineHtml(textHtml) {
        let primaryText: string = "";
        let bottomText: string = "";
        let extraText: string = "";
        let openParenIndex: number = textHtml.indexOf("(");
        let closeParenIndex: number = textHtml.indexOf(")");
        let tla;
        let rest;

        /* main suggestions should always have parentheses */
        if (openParenIndex !== -1 && closeParenIndex !== -1) {
            primaryText = textHtml.substring(0, openParenIndex);
            bottomText = textHtml.substring(openParenIndex + 1, closeParenIndex);
            let dashIndex: number = bottomText.indexOf("-");
            if (dashIndex !== -1) {
                tla = bottomText.substring(0, dashIndex).replace(/&nbsp;/i, "").trim();
                rest = bottomText.substring(dashIndex + 1, bottomText.length);
            } else {
                tla = bottomText;
                rest = "";
            }
            bottomText = "(<B>" + tla + "</B>)" + rest;
            if (closeParenIndex + 1 < textHtml.length) {
                extraText = textHtml.substring(closeParenIndex + 1, textHtml.length);
            }
        } else {
            primaryText = textHtml;
        }

        return createMultiLineHtml(primaryText, extraText, bottomText);
    }

    function convertChildToMultiLineHtml(textHtml) {
        let dashIndex = textHtml.indexOf("-");
        if (dashIndex !== -1) {
            let tla = textHtml.substring(0, dashIndex).replace(/&nbsp;/i, "").trim();
            let rest = textHtml.substring(dashIndex + 1, textHtml.length);

            return "(<B>" + tla + "</B>)" + rest;
        }
        // Handling the case where hypen is not available after TLA in the ESS display text (example - YQG, Windsor ..)
        /*
         else {
         var result = new RegExp("^([A-Z]{3}),(.*)").exec(textHtml);
         if (result && result.length && result[1] && result[2]) {
         return "(<B>" + result[1] + "</B>)" + result[2];
         }
         }*/
        return textHtml;
    }

    function getMercuryWizardTab(): string {
        return $("li.tab:visible").children("button.on").data("lob");
    }

    function formatText(html) {
        if ("flight" === getMercuryWizardTab()) {
            return suggestionResult.showAsHierarchy ? convertChildToMultiLineHtml(html) :
                convertMainToMultiLineHtml(html);
        } else {
            return html;
        }
    }

    let iconHtml = makeIconHtml();
    let textHtml = suggestionResult.regionNames.displayName;

    if (suggestionResult.showAsHierarchy) {
        textHtml = appendDistanceForNearbyAirportIfApplicable();
    }

    let iconAndTextHtml = iconHtml + formatText(textHtml);

    return suggestionResult.showAsHierarchy ? (`<div class="child-suggestion" style="padding-left:` +
        ("none" === suggestionResult.icon ? `12px` : `1.88235em`) +
        `; width: 100%;">` + iconAndTextHtml + `</div>`) : iconAndTextHtml;

});
